import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { KbMyBulletinService } from 'src/app/services/feature/kb-My-Bulletin/kb-my-bulletin.service';
import { DownloadItem } from '../../kb-MyPriceList/kb-my-price-list/kb-my-price-list.component';
import { OccConfig } from '@spartacus/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-kb-my-bulletin-board',
  templateUrl: './kb-my-bulletin-board.component.html',
  styleUrls: ['./kb-my-bulletin-board.component.scss'],
  standalone: false
})
export class KbMyBulletinBoardComponent {
  url: any;
  selectAll: boolean = false;
  sub = new Subscription();
  isMobile: boolean;
  Pricing: boolean[] = [];
  baseUrl = this.config?.backend?.occ?.baseUrl + '/';
  pricelist$: Observable<any> = this.service.getApi();
  downloadError: boolean;
  platformId = inject(PLATFORM_ID);

  constructor(
    private breakpointObserver: BreakpointObserver,
    private service: KbMyBulletinService,
    private cdr: ChangeDetectorRef,
    private config: OccConfig
  ) {
    this.sub.add(
      this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
        this.isMobile = result.matches;
      })
    );
  }

  ngOnInit() {
    this.sub.add(this.service.getApi().subscribe((res: any) => {
      this.url = res;
      this.initializePricingArray();
      this.cdr.detectChanges();
    }));
  }

  initializePricingArray() {
    if (this.url && this.url.reports) {
      this.Pricing = Array(this.url.reports.length).fill(false);
    }
  }

  namefilter(filename): string {
    return filename.replace(/\..*/, '');
  }

  selectingAll() {
    this.selectAll = !this.selectAll;
    if (this.selectAll) {
      this.Pricing = this.Pricing.map(() => true);
    } else {
      this.Pricing = this.Pricing.map(() => false);
    }
  }
  transformObjectToDownloadItems(data: any[], baseUrl: string): DownloadItem[] {
    return data.map((item) => ({
      download: baseUrl + item.downloadUrl,
      filename: item.code,
    }));
  }

  /*  downloadFiles() {
     const selectedFiles = this.url.reports.filter((reports, index) => this.Pricing[index]);
     if (selectedFiles.length === 0) {
       return;
     } else {
       const downloadableFormat = this.transformObjectToDownloadItems(selectedFiles, this.baseUrl);
       this.downloadFile(downloadableFormat);
     }
   } */
  downloadFiles() {
    const selectedFiles = this.url.reports.filter((reports, index) => this.Pricing[index]);

    if (selectedFiles.length === 0) {
      return;
    }

    const downloadableFormat = this.transformObjectToDownloadItems(selectedFiles, this.baseUrl);

    const selectedCodes = selectedFiles.map(item => item.uuid);

    this.downloadFile(downloadableFormat, selectedCodes);
  }

  /*  downloadFile(files: { download: string; filename: string }[]) {
     if (isPlatformBrowser(this.platformId)) {
       async function downloadNext(i: number): Promise<void> {
         if (i >= files.length) {
           return;
         }
         const a = document.createElement('a');
         a.href = files[i].download;
         a.target = '_parent';
         if ('download' in a) {
           a.download = files[i].filename;
         }
 
         (document.body || document.documentElement).appendChild(a);
         if (a.click) {
           a.click();
         } else {
           (a as any).click();
         }
         a.parentNode?.removeChild(a);
         await new Promise((resolve) => setTimeout(resolve, 1000));
 
         await downloadNext(i + 1);
       }
 
       downloadNext(0)
         .then(() => console.log('All downloads completed!'))
         .catch((error) => console.error('Download error:', error));
     }
   } */
  downloadFile(
    files: { download: string; filename: string }[],
    selectedCodes: string[]
  ) {
    if (isPlatformBrowser(this.platformId)) {

      const downloadNext = async (i: number): Promise<void> => {
        if (i >= files.length) {
          return;
        }

        const a = document.createElement('a');
        a.href = files[i].download;
        a.target = '_parent';

        if ('download' in a) {
          a.download = files[i].filename;
        }

        (document.body || document.documentElement).appendChild(a);
        a.click();
        a.parentNode?.removeChild(a);

        await new Promise(resolve => setTimeout(resolve, 1000));
        await downloadNext(i + 1);
      };

      downloadNext(0)
        .then(() => {


          this.service.postApi(selectedCodes).subscribe({
            next: () => console.log('Timestamp updated successfully'),
            error: err => console.error('Timestamp API failed', err)
          });
        })
        .catch(error => console.error('Download error:', error));
    }
  }
}
